export const TYPE_IDS = {
    REQUEST_CARD: 1,
    PUSH_S2S_TRANSFER: 2,
    PUSH_S2B_TRANSFER: 0,
    INITIATE_EXCHANGE: 3,
    NEW_CASHIN_ORDER: 4,
    NEW_CASHOUT_ORDER: 5,
    CONFIRM_ONE_PAYROLL: 6,
    CONFIRM_PAYROLL: 7,
    PUSH_BANK_TRANSFER: 8,
    ADD_LEGAL_EMPLOYEE: 9,
    ADD_EMPLOYEE: 9,
    SUBMIT_QUICK_PAY: 10,
    CONFIRM_QUICK_PAY: 11,

}
